import React from 'react'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { RoutePath } from '../../../constants/SitePaths';
import { Form, Input, Button } from 'antd';
import { Auth } from '../../../services/Auth';
import { injectIntl, FormattedMessage } from 'react-intl'
import { sendCode } from "../../../actions/AccountActions";

const FormItem = Form.Item;

class ForgotPasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verificationCodeIsSent: false
        };
    }

    handleSubmit = (form, props) => {

        form.validateFields((err, values) => {
            if (!err) {
                this.props.dispatch(sendCode(values, props.history, this.props.intl));
            }
        });
    };

    render() {
        if (this.props.account.isLoggedIn === true && Auth.isAuthenticated()) {
            return <Redirect to='/' />
        }

        //Form Item Layout
        const { getFieldDecorator } = this.props.form;

        return (
            <div className="ta--login-form">
                <Form>
                    <div className="ta--form-title ta--mb-24 rtl--text-right"><FormattedMessage id="forgot_password" /></div>

                    <FormItem label={this.props.intl.messages.email}>
                        {getFieldDecorator('email', {
                            rules: [
                                { required: true, message: this.props.intl.messages.email_required },
                            ],
                        })(
                            <Input placeholder={this.props.intl.messages.email} />
                        )}
                    </FormItem>

                    <FormItem>
                        <Button loading={this.props.account.isLoading} type="primary" htmlType="submit"
                            className="button ta-w100"
                            onClick={this.handleSubmit.bind(this, this.props.form, this.props, this.state)}>
                            <FormattedMessage id="send_verification_code" />
                        </Button>
                    </FormItem>
                    <div className="ta--text-center ta--mb-24">
                        <Link to={RoutePath.LOGIN}>
                            <span className='ta--txt-mid-dark'>{this.props.intl.messages.go_to}</span> <span>{this.props.intl.messages.sign_in}</span>
                        </Link>
                    </div>
                </Form>
            </div>
        );
    }
}

const SendVerificationCode = Form.create()(ForgotPasswordForm);

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
};

const mapStateToProps = state => {
    return {
        account: state.account
    }
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(SendVerificationCode));


// WEBPACK FOOTER //
// ./src/routes/account/forgotPassword/SendVerificationCode.js